exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".format-table table{table-layout:fixed}.format-table .ellipsis-th{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;word-break:keep-all}.format-table .resize-table-th{position:relative}.format-table .resize-table-th .table-draggable-handle{height:100%!important;bottom:0;left:auto!important;right:-5px;cursor:col-resize;-ms-touch-action:none;touch-action:none}", ""]);

// exports
